import type { SanityPortableText } from '@libs/ui';

export const DISNEYLAND_CAMPAIGN_ID = '69104da0-7bd5-425b-9a7f-2876c19fe513';
export enum DisneylandCampaignMarkets {
  sv = 'www.sembo.se',
  dk = 'www.sembo.dk',
  no = 'www.sembo.no',
}

export type MarketLocale = keyof typeof DisneylandCampaignMarkets;

export interface DisneylandCampaignHotels {
  hotelCodes: string[];
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  giftCardValue: 100 | 150;
}

export const DISNEYLAND_CAMPAIGN_HOTELS: DisneylandCampaignHotels[] = [
  { hotelCodes: ['1959544', 'F-7110'], giftCardValue: 100 }, // Disney Davy Crockett Ranch
  { hotelCodes: ['3197301', 'F-7111'], giftCardValue: 100 }, // Disney Hotel Santa Fe
  { hotelCodes: ['2990812', 'F-7112'], giftCardValue: 100 }, // Disney Hotel Cheyenne
  { hotelCodes: ['2776863', 'F-7113'], giftCardValue: 100 }, // Disney Sequoia Lodge
  { hotelCodes: ['2734466', 'F-7114'], giftCardValue: 150 }, // Disney Newport Bay Club
  { hotelCodes: ['2676072', 'F-7115'], giftCardValue: 150 }, // Disney Hotel New York – The Art of Marvel
];

export interface DisneylandCampaignDetailedBannerData {
  hotelName: string | undefined;
  giftCardAmount: number | undefined;
}

export interface DisneylandCampaignBannerData {
  title: string | undefined;
  content: string | undefined;
}

export interface DisneylandCampaignModalData {
  title: string | undefined;
  content: string | undefined;
  description: SanityPortableText[] | undefined;
}
